import axios from 'axios';
import moment from 'moment-timezone'


export default {

  getPurchaseOrder(poId){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/purchase-orders/process/"+poId)
        .then(response=>{
          return response.data;
        })
  }

}
